import * as types from './Types.js';

export function findParticipantes(filter) {
  return ({ fetch }) => ({
    type: types.LICITACOES_PARTICIPANTES,
    payload: fetch(`/api/licitacoes/participantes-search?${filter}`)
  });
}

export function findParticipanteDetalhes(participante, entidade, exercicio) {
  return ({ fetch }) => ({
    type: types.LICITACOES_PARTICIPANTE,
    payload: fetch(
      `/api/licitacoes/participante-licitacoes/${participante}?entidade=${entidade}&exercicio=${exercicio}`
    )
  });
}
